// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","trendsBlock":"uwMp2","links":"_21Oeq","link":"_6m37P _36PPP _2AZKg"};